import ContentList, { ContentListBaseProps } from './ContentList';

export default function ContentUnorderedList(props: ContentListBaseProps) {
    return <ContentList items={props.items} key={props.id} id={props.id.toString()} type='ul' />;
}
